import { useStore } from 'vuex'

export default () => {
  const { commit } = useStore()

  function orderTask (parsedData) {
    parsedData.payload.value.forEach((item, index) => {
      commit('updateTask', {
        id: item,
        order: index
      })
    })
  }

  function updateTask (parsedData) {
    commit('updateTask', {
      id: parsedData.payload.id,
      ...parsedData.payload.value
    })
  }

  function createTask (parsedData) {
    commit('addTask', parsedData.payload.value)
  }

  function deleteTask (parsedData) {
    commit('deleteTask', parsedData.payload.value)
  }

  function orderRow (parsedData) {
    parsedData.payload.value.forEach((item, index) => {
      commit('updateRow', {
        id: item,
        order: index
      })
    })
  }

  function updateRow (parsedData) {
    commit('updateRow', {
      id: parsedData.payload.id,
      ...parsedData.payload.value
    })
  }

  function createRow (parsedData) {
    commit('addRow', parsedData.payload.value)
  }

  function deleteRow (parsedData) {
    commit('deleteRow', parsedData.payload.value)
  }

  return {
    orderTask,
    updateTask,
    createTask,
    deleteTask,
    orderRow,
    updateRow,
    createRow,
    deleteRow
  }
}
